import React, {Component, Fragment} from 'react';
import {Badge, Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {Trans, withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {i18nizeDate, numberWithCommas} from '../../../../helpers/Utils';
import {baseTokenSymbol, reactTableText} from '../../../../constants/configs';
import TransactionDetails from '../../../../containers/TransactionDetails';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ToolTip from '../../../../components/ToolTip';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {keyBy, mapValues, omit, values} from 'lodash';
import {Link} from 'react-router-dom';
import {store} from '../../../../AppRenderer';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import {NotificationManager} from '../../../../components/common/react-notifications';
import Rbac from "../../../../components/Rbac";
import ModalManager from "../../../../components/modal/ModalManager";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      withdraws: [],
      pages: -1,
      loading: false,
      refreshing: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
      processing: {},
    };
    this.networks = store.getState().app.networks;
    this.tokens = keyBy(store.getState().general.tokens, 'symbol');
    this.renderTokenFilter = this.renderTokenFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  fetchWithdraws = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users-withdraws',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            status: 'PENDING',
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'timestamp') : null),
            ...(this.state.selectedStartDate ? {from: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {to: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        withdraws: data.withdraws,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchWithdraws(state);
    this.setState({loading: false});
  };

  getColumns = t => [
    {
      Header: t('First Name'),
      accessor: 'firstName',
      width: 100,
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
      width: 150,
    },
    {
      Header: t('Email'),
      accessor: 'email',
    },
    {
      Header: t('Amount'),
      accessor: 'amount',
      Cell: props => {
        if (props.original.token === baseTokenSymbol) {
          const fee = this.networks[baseTokenSymbol].supportedTokens[baseTokenSymbol].withdraw.withdrawalFeePolicy.value;
          return (
            <div className="d-flex flex-column">
              <div>{`${t('withdraw amount')}: ${numberWithCommas(Number(props.value))}`}</div>
              <div>{`${t('withdraw fee')}: ${numberWithCommas(fee)}`}</div>
              <div>{`${t('Net amount paid')}: ${numberWithCommas(Number(props.value) - Number(fee))}`}</div>
            </div>
          );
        }
        return (
          <span>{numberWithCommas(Number(props.value))}</span>
        );
      },
    },
    {
      Header: t('Token'),
      accessor: 'token',
      filterable: true,
      width: 160,
      Filter: this.renderTokenFilter,
      Cell: props => <span>{this.tokens[props.value] ? this.tokens[props.value].localeName : props.value}</span>,
    },
    {
      Header: t('Date'),
      accessor: 'timestamp',
      width: 160,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('Actions'),
      minWidth: 100,
      maxWidth: 150,
      accessor: 'token',
      Cell: props =>
        <div className='d-flex flex-row align-items-center justify-content-around'>
          {props.value === 'TMN' &&
            this.state.processing[props.original.id] ?
              <Badge className="font-weight-normal" style={{fontSize: 10, marginBottom: 5}} color="warning" pill>
                {`${t('Checking')}...`}
              </Badge> :
              <Rbac permission='update_user-withdraw-status'>
                <ToolTip id={props.original.id} text={t('Auto-process')}>
                  <span className="text-large text-success" onClick={async () => {
                    await this.onPressAutoProcess(props.original);
                  }}>
                    <i className="icon-Reload cursor-pointer font-weight-semibold"/>
                  </span>
                </ToolTip>
            </Rbac>
          }
          <ToolTip id={`view_${props.original.userId}`} text={t('View Stats')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.original.userId,
            }}>
              <i className="simple-icon-eye view-icon text-large"/>
            </Link>
          </ToolTip>
        </div>,
    },
  ];

  onPressAutoProcess = transaction => {
    const {t} = this.props;
    const {id, amount, firstName, lastName} = transaction;
    ModalManager.open({
      isOpen: true,
      title: t('Auto Process Confirm'),
      body:
          <div className="text-one">
            <Trans
                i18nKey="confirm_auto_bank_withdraw"
                values={{
                  firstName,
                  lastName,
                  amount: numberWithCommas(Number(amount) - 4000),
                }}
                components={[
                  <div className="text-one d-inline-block text-info font-weight-semibold"/>
                ]}
            />
          </div>,
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            this.sendAutoProcessReq(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'light',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  sendAutoProcessReq = async transactionId => {
    const {t} = this.props;
    this.setState(({processing}) => ({
      processing: {
        ...processing,
        [transactionId]: true,
      },
    }));
    try {
      await Api.invoke('POST', '/admin-ui/process-withdraw-request', {
        transactionId,
      }, {
        cancelToken: null,
      });
      this.table.fireFetchData();
      NotificationManager.success(t('Auto process request sent successfully'), t('Message'));
    } catch (e) {
    } finally {
      this.setState(({processing}) => ({
        processing: {
          ...processing,
          [transactionId]: false,
        },
      }));
    }
  };

  refreshList = async () => {
    const {t} = this.props;
    this.setState({refreshing: true});
    await this.fetchWithdraws(this.table.state);
    this.setState({refreshing: false});
    NotificationManager.info(t('Withdraws list updated successfully'), t('Message'));
  };

  renderTokenFilter({filter, onChange}) {
    const {t} = this.props;
    const options = values(this.tokens).map(token => ({
      value: token.symbol, label: token.localeName,
    }));
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  updateList = (index, params) => {
    const {withdraws} = this.state;
    let list = [...withdraws];
    list.splice(index, 1, {...withdraws[index], ...params});
    this.setState({withdraws: list});
  };

  render() {
    const {t, match} = this.props;
    const {withdraws, pages, loading, expanded, refreshing} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="d-flex flex-row justify-content-end align-items-center">
                  <Button
                    outline
                    disabled={refreshing || loading}
                    className="d-flex align-items-center justify-content-center"
                    onClick={this.refreshList}>
                    <i className='icon-File-Refresh text-large'/>
                    <span className="mx-1">{t('Refresh')}</span>
                  </Button>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={withdraws}
                  pages={pages}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  expanded={expanded}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  onExpandedChange={this.onExpanded}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={row => {
                    const {original} = row;
                    return (
                      <TransactionDetails
                        transaction={{
                          ...original,
                          type: 'withdraw',
                          index: row.index
                        }}
                        updateList={this.updateList}
                      />
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
